<div class="opstate-container" [ngClass]="{'selected': selected}">
  <div class="device-table-container">
    <table #deviceOperationStateItemsTable="matSort" mat-table [dataSource]="deviceOperationStateItems" matSort
      aria-label="operation-state" class="operation-state-table">
      <ng-container matColumnDef="operationStateItemNum">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.opstate-items.header.num' |
          translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.operationStateItemNum}}</td>
      </ng-container>
      <ng-container matColumnDef="nameDisplayText">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.opstate-items.header.name' |
          translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.nameDisplayText}}</td>
      </ng-container>
      <ng-container matColumnDef="lastUpdatedTimestamp">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.opstate-items.header.last-updated'
          |
          translate}}</th>
        <td mat-cell *matCellDef="let element">
          {{element.lastUpdatedTimestamp | defaultDate}}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastChangeByMessageId">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.opstate-items.header.last-message'
          |
          translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.lastChangeByMessageId}}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="filteredDeviceOperationStateItemsColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: filteredDeviceOperationStateItemsColumns;" class="element-row"
        (click)="selectOpstateItem(element)"
        [matTooltip]="'devices.detail.opstate-items.attr-count' | translate : { count: element.attributes?.length ?? 0}"
        matTooltipPosition="above" [matTooltipShowDelay]="1000">
      </tr>
    </table>
  </div>
  <mat-paginator #deviceOperationStateItemsPaginator [pageSizeOptions]="[10, 25, 50]" [showFirstLastButtons]="!mobile"
    [hidePageSize]="mobile">
  </mat-paginator>
  <mat-button-toggle-group [multiple]="true" #deviceOperationStateItemsGroup="matButtonToggleGroup"
    [(ngModel)]="deviceOperationStateItemsColumnsToggle" class="opstate-toggle">
    <mat-button-toggle value="operationStateItemNum" class="opstate-toggle-item">
      <span>{{'devices.detail.opstate-items.header.num' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="nameDisplayText" class="opstate-toggle-item">
      <span>{{'devices.detail.opstate-items.header.name' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="lastUpdatedTimestamp" class="opstate-toggle-item">
      <span>{{'devices.detail.opstate-items.header.last-updated' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="lastChangeByMessageId" class="opstate-toggle-item">
      <span>{{'devices.detail.opstate-items.header.last-message' | translate}}</span>
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
<div class="opstate-container opstate-detail" [ngClass]="{'selected': selected}">
  <div class="header-container">
    <button class="opstate-back-button" mat-flat-button color="primary" (click)="selected = undefined" matRipple
      [ngClass]="{ show: selected }">
      <mat-icon class="opstate-back-icon">arrow_back</mat-icon>
    </button>
    <h1 class="selected-title">{{ selected?.nameDisplayText }}</h1>
  </div>
  <div #opstateAttrTable class="opstate-attr-table-container">
    <table #deviceOperationStateItemsDetailTable="matSort" mat-table [dataSource]="deviceOperationStateItemsDetail"
      matSort aria-label="element-detail">
      <ng-container matColumnDef="operationStateItemAttributeNum">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.opstate-items.header.num' | translate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.operationStateItemAttributeNum}}</td>
      </ng-container>
      <ng-container matColumnDef="nameDisplayText">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.opstate-items.header.name' | translate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.nameDisplayText}}</td>
      </ng-container>
      <ng-container matColumnDef="valueDisplayText">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.opstate-items.header.value' |
          translate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.valueDisplayText}}</td>
      </ng-container>
      <ng-container matColumnDef="operationStateItemAttributeType">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.opstate-items.header.type' | translate}}
        </th>
        <td mat-cell *matCellDef="let element">{{element.operationStateItemAttributeType}}</td>
      </ng-container>
      <ng-container matColumnDef="lastUpdatedTimestamp">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.opstate-items.header.last-updated' |
          translate}}</th>
        <td mat-cell *matCellDef="let element">
          {{element.lastUpdatedTimestamp| defaultDate}}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastChangeByMessageId">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'devices.detail.opstate-items.header.last-message' |
          translate}}</th>
        <td mat-cell *matCellDef="let element">{{element.lastChangeByMessageId}}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="filteredDeviceOperationStateItemAttributesColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: filteredDeviceOperationStateItemAttributesColumns;"></tr>
    </table>
  </div>
  <mat-paginator #deviceOperationStateItemsDetailPaginator [pageSizeOptions]="[10, 25, 50]"
    [showFirstLastButtons]="!mobile" [hidePageSize]="mobile">
  </mat-paginator>
  <mat-button-toggle-group [multiple]="true" #deviceOperationStateItemsDetailGroup="matButtonToggleGroup"
    [(ngModel)]="deviceOperationStateItemAttributesColumnsToggle" class="opstate-toggle">
    <mat-button-toggle value="operationStateItemAttributeNum" class="opstate-attr-toggle-item">
      <span>{{'devices.detail.opstate-items.header.num' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="nameDisplayText" class="opstate-attr-toggle-item">
      <span>{{'devices.detail.opstate-items.header.name' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="valueDisplayText" class="opstate-attr-toggle-item">
      <span>{{'devices.detail.opstate-items.header.value' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="operationStateItemAttributeType" class="opstate-attr-toggle-item">
      <span>{{'devices.detail.opstate-items.header.type' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="lastUpdatedTimestamp" class="opstate-attr-toggle-item">
      <span>{{'devices.detail.opstate-items.header.last-updated' | translate}}</span>
    </mat-button-toggle>
    <mat-button-toggle value="lastChangeByMessageId" class="opstate-attr-toggle-item">
      <span>{{'devices.detail.opstate-items.header.last-message' | translate}}</span>
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>